import { createFileRoute } from '@tanstack/react-router'
import { AnonymousReportDetailPage } from '@/pages/anonymous-reports/AnonymousReportDetailPage'

export const Route = createFileRoute(
  '/(protected)/workspaces/$workspaceId/anonymous-reports_/$reportId'
)({
  staticData: {
    pageHeader: { title: 'Anonymous report', pad: false, scroll: false },
  },
  component: AnonymousReportDetailRoute,
})
function AnonymousReportDetailRoute() {
  const { workspaceId, reportId } = Route.useParams()
  return (
    <AnonymousReportDetailPage workspaceId={workspaceId} reportId={reportId} />
  )
}
